<template>
  <div>
    <Head :title="title" />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Name')" />
          <select-input v-model="form.department_id" :error="form.errors.department_id" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Department')">
            <option :value="null">{{ __('Select Department') }}</option>
            <option v-for="department in departments" :key="department.id" :value="department.id">{{ department.name }}</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ __('Create') }} {{ __('Channel') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Link, Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Create Channel' },
  components: {
    LoadingButton,
    TextInput,
    SelectInput,
    Link,
    Head,
  },
  layout: Layout,
  props: {
      title: String,
      departments: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        department_id: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('channels.store'))
    },
  },
}
</script>
